// extracted by mini-css-extract-plugin
export default {"meter":"styles_meter__IfzUa","value":"styles_value__n948r","title":"styles_title__p+W-B"};